import { epic$ } from '@redux/store';
import TypeaheadLocationType from 'enums/typeaheadLocationType';
import LocationType from './enums/locationType';
import {
  fetchResultCountsEpic,
  getResultCountsEpic,
  fetchResultListingsEpic,
  fetchResultFacetsEpic,
  getResultFacetsEpic,
  updateFacetsEpic,
  updateZipSearchesOnBuildersResult,
  updateNeighborhoodSearchesOnBuildersResult,
  updateSchoolDistrictSearchesOnBuildersResult,
} from './redux/epics';
import {
  isNotCommunityLocationType,
  selectConsumerPromos,
  selectCondosAndTownHomes,
  selectFacts,
  selectFeatures,
  selectListingCount,
  selectResultsModifiers,
  selectPage,
  selectProduct,
  selectProductType,
  selectResults,
  selectCounties,
  selectBrand,
  selectHomeStatus,
  selectLocation,
  selectLocationContentContext,
  selectMarketingStatus,
  pageCountSelector,
  selectPaginationContext,
  selectContentTemplateTypeModifiers,
  selectSubdirectory,
  moveInDateSelector,
  selectBrandFilterContext,
  selectSearchResultFacetsTrackingCommonProperties,
  selectLocationType,
  selectResultType,
  selectPaging,
  selectProductAndResultType,
  selectSearchCommandContext,
  selectSnippetCommand,
  selectSorting,
  activeAdultCommunitiesSelector,
  fetchingResultsCallStatusesSelector,
  selectFetchResultListingsStatus,
  facetsSelector,
  selectSearchCount,
  selectAppliedFacets,
  selectFetchCountsStatusAndsCounts,
  facetsPanelSelector,
  homeFactsSelectors,
  selectLinkedPopularPillsFilters,
  selectPageSize,
  selectNatureAreas,
  selectPool,
  selectGolfCourse,
  selectGreen,
  selectSportsFacilities,
  selectParks,
  selectViews,
  selectWaterfront,
  selectGatedCommunity,
  selectBathrooms,
  selectBedrooms,
  selectLuxury,
  selectMaximumPrice,
  selectMinimumPrice,
  selectLivingAreas,
  selectGarages,
  selectStories,
  selectPrimaryBedroom,
  selectRvGarage,
  selectReviews,
  selectMoveInDateRange,
  selectPriceReduction,
  selectResultTypeAndSorting,
  selectSearchParameters,
  selectSearchModifiers,
  selectHomeOwnersAssociationFee,
  selectResultsType,
  extendedFacetsSelector,
   selectIsNeighborhoodType,
  selectIsSchoolDistrictType,
  selectMarketId,
} from './redux/selectors';
import getResults$ from './apis/getResults';
import { searchParametersSlice, facetsSlice } from './redux/slices';
import MoveInDate from './enums/moveInDate';
import PlanStatus from './enums/planStatus';
import SpecStatus from './enums/specStatus';
import ResultType from './enums/resultType';
import ProductType from './enums/productType';
import SortType from './enums/sortType';
import UrlSubdirectoryTypes from '../../pages/searchResults/enums/urlSubdirectoryTypes';
import PriceFilterLabel from './components/priceFilterLabel';
import SelectMoveInDate from './components/selectMoveInDate';
import BedroomAndBathroomFilterLabel from './components/bedroomAndBathroomFilterLabel';
import {
  getInventoryStatusCombination,
  hasReadyToBuild,
  hasAvailableNow,
  hasInventoryStatusCombination,
  hasModelHome,
} from './services/homeStatusValidator';

const { actions, reducer } = searchParametersSlice;
const facetsActions = facetsSlice.actions;
const facetsReducers = facetsSlice.reducer;
const facetPriceLabel = document.querySelector('[data-price-toggle-label]');
const moveInDateElement = document.querySelector('[data-move-in-date-filter]');
const facetBedroomBathroomLabel = document.querySelector('[data-bedroom-bathroom-label]');

epic$.next(fetchResultCountsEpic);
epic$.next(getResultCountsEpic);
epic$.next(fetchResultListingsEpic);
epic$.next(fetchResultFacetsEpic);
epic$.next(getResultFacetsEpic);
epic$.next(updateFacetsEpic);
epic$.next(updateZipSearchesOnBuildersResult);
epic$.next(updateNeighborhoodSearchesOnBuildersResult);
epic$.next(updateSchoolDistrictSearchesOnBuildersResult);

const searchParametersSelectors = {
  selectLocation,
  selectProductType,
  selectContentTemplateTypeModifiers,
};

(() => new PriceFilterLabel(facetPriceLabel))();
(() => new BedroomAndBathroomFilterLabel(facetBedroomBathroomLabel))();

const selectMoveInDate = new SelectMoveInDate(moveInDateElement);
selectMoveInDate.toggleActiveClass();

export { LocationType };
export { TypeaheadLocationType };
export {
  actions as searchParametersActions,
  reducer as searchParametersReducers,
  facetsActions,
  facetsReducers,
  isNotCommunityLocationType,
  pageCountSelector,
  searchParametersSelectors,
  selectPaginationContext,
  moveInDateSelector,
  selectBrand,
  selectLocationType,
  selectResultType,
  selectProduct,
  selectProductAndResultType,
  selectLocation,
  selectListingCount,
  selectPage,
  facetsSelector,
  selectSorting,
  activeAdultCommunitiesSelector,
  fetchingResultsCallStatusesSelector,
  selectFetchResultListingsStatus,
  MoveInDate,
  SpecStatus,
  PlanStatus,
  ResultType,
  ProductType,
  SortType,
  UrlSubdirectoryTypes,
  selectCounties,
  selectSubdirectory,
  getInventoryStatusCombination,
  hasReadyToBuild,
  hasAvailableNow,
  hasInventoryStatusCombination,
  hasModelHome,
  selectBrandFilterContext,
  selectSearchResultFacetsTrackingCommonProperties,
  selectSnippetCommand,
  selectSearchCount,
  selectConsumerPromos,
  selectCondosAndTownHomes,
  selectFacts,
  selectFeatures,
  selectMarketingStatus,
  selectHomeStatus,
  selectAppliedFacets,
  selectResultsModifiers,
  selectResults,
  selectSearchCommandContext,
  selectLocationContentContext,
  selectFetchCountsStatusAndsCounts,
  facetsPanelSelector,
  homeFactsSelectors,
  selectLinkedPopularPillsFilters,
  selectPageSize,
  selectPaging,
  selectProductType,
  selectNatureAreas,
  selectPool,
  selectGolfCourse,
  selectGreen,
  selectSportsFacilities,
  selectParks,
  selectViews,
  selectWaterfront,
  selectGatedCommunity,
  selectBathrooms,
  selectBedrooms,
  selectLuxury,
  selectMaximumPrice,
  selectMinimumPrice,
  selectLivingAreas,
  selectGarages,
  selectStories,
  selectPrimaryBedroom,
  selectRvGarage,
  selectReviews,
  selectMoveInDateRange,
  selectPriceReduction,
  selectResultTypeAndSorting,
  selectSearchParameters,
  getResults$,
  selectSearchModifiers,
  selectHomeOwnersAssociationFee,
  selectResultsType,
  extendedFacetsSelector,
  selectIsNeighborhoodType,
  selectIsSchoolDistrictType,
  selectMarketId,
};

require('./components/priceDualRangeSlider');
require('./components/advancedFiltersPanel');
require('./components/advancedClearButton');
require('./components/clearButton');
require('./redux/listeners');
